import axios from 'axios';
import Vue from 'vue';
import Vuex from 'vuex';
import OurRangeNewVehicles from './OurRangeNewVehicles.vue';
import debounce from 'lodash/debounce';

export default function (ourRangeNewVehicles) {
    const ourRangeNewVehiclesVueApp = ourRangeNewVehicles.querySelector('.cms-content-our-range-single-brand__vue-app');

    Vue.use(Vuex);

    const store = new Vuex.Store({
        state: {
            selectedOptions: {
                brand: null,
                model: [],
                type: [],
                bodystyle: [],
                minPrice: null,
                maxPrice: null,
                fuelType: [],
            },
            availableOptions: {
                model: [],
                type: ['Car', 'Van'],
                bodystyle: [],
                fuelType: [],
                minPrice: 0,
                maxPrice: null,
            },
            initialized: false,
            loadingOptions: true,
            loadingVehicles: true,
            vehicles: [],
            quoteValidDate: null,
        },
        actions: {
            async initFromUrl({ dispatch }) {
                await dispatch('getOptions');
            },
            getOptions:
                debounce(({ commit, state, dispatch }) => {
                    return new Promise((resolve, reject) => {
                        axios.get('/api/our-range/options', {
                            params: state.selectedOptions
                        })
                            .then(response => {
                                commit('setLoadingOptions', false);
                                commit('setAvailableOptions', response.data);
                                commit('setInitialized', true);
                                dispatch('getVehicles');
                                resolve(response);
                            })
                            .catch(error => {
                                console.error('Error getting options');
                                console.error(error);
                                reject(error);
                            });
                    });
                },
                    350,
                    {
                        leading: false,
                        trailing: true
                    }
                ),
            getVehicles:
                debounce(({ commit, state }) => {
                    if( Array.isArray(state.selectedOptions.bodystyle) && state.selectedOptions.bodystyle[0] === null){
                        state.selectedOptions.bodystyle = null
                    }
                    return new Promise((resolve, reject) => {
                        axios.get('/api/our-range', {
                            params: state.selectedOptions
                        })
                            .then(response => {
                                commit('setLoadingVehicles', false);
                                commit('setQuoteValidDate', response.data.meta.quote_valid_date);
                                const vehicles = [];
                                response.data.data.forEach((vehicle) => {
                                    vehicles.push(vehicle);
                                });
                                commit('setVehicles', vehicles);
                                // setupFinance();
                                resolve(response);
                            })
                            .catch(error => {
                                console.error('Error getting vehicles');
                                console.error(error);
                                reject(error);
                            });
                    });
                },
                    350,
                    {
                        leading: false,
                        trailing: true
                    }
                ),
            getOptionsAndVehicles({ commit, dispatch }) {
                dispatch('getOptions');
                dispatch('getVehicles');
            },
            updateOptions({ commit, dispatch }, options) {
                commit('updateOptions', options);
                dispatch('getOptionsAndVehicles');
            },
        },
        mutations: {
            setSelectedBrand(state, brand) {
                state.selectedOptions.brand = brand;
            },
            setSelectedModels(state, models) {
                state.selectedOptions.model = models;
            },

            setAvailableOptions(state, options) {
                if (typeof options !== 'object') return;

                Object.keys(options).forEach(key => {
                    if (typeof state.availableOptions[key] == 'undefined') return;

                    if (key == 'type') {
                        state.availableOptions[key] = options[key].map(
                            t => t.charAt(0).toUpperCase() + t.slice(1)
                        );
                        return;
                    }

                    state.availableOptions[key] = options[key];
                });

                // Apply url models once on page load
                if (!state.initialized) {
                    const params = new URLSearchParams(window.location.search);
                    const modelParam = params.get('model');

                    if (modelParam) {
                        const modelsFromUrl = modelParam.split(',');

                        state.selectedOptions.model = state.availableOptions.model.filter(m =>
                            modelsFromUrl.includes(m)
                        );
                    }

                    const maxPriceParam = params.get('maxPrice');
                    console.log('max price', maxPriceParam)
                    if (maxPriceParam) {
                        state.selectedOptions.maxPrice = Number(maxPriceParam);
                    }
                }
            },

            updateOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.selectedOptions[key] == 'undefined') {
                        return;
                    }
                    state.selectedOptions[key] = options[key];
                });
            },
            setVehicles(state, vehicles) {
                state.vehicles = vehicles;
            },
            setQuoteValidDate(state, quoteValidDate) {
                state.quoteValidDate = quoteValidDate;
            },
            setInitialized(state, initialized) {
                state.initialized = initialized;
            },
            setLoadingOptions(state, loadingOptions) {
                state.loadingOptions = loadingOptions;
            },
            setLoadingVehicles(state, loadingVehicles) {
                state.loadingVehicles = loadingVehicles;
            }
        }
    })

    const ourRangeNewVehiclesVueAppVue = new Vue({
        el: ourRangeNewVehiclesVueApp,
        store: store,
        components: {
            OurRangeNewVehicles,
        },
        created() {
            this.$store.dispatch('initFromUrl');
        }
    });
}